<script setup>
// Foto de perfil ampliada, como no WhatsApp: fundo escuro, imagem no centro,
// fecha no X, no Esc ou clicando fora da imagem.
import { onKeyStroke } from '@vueuse/core';
import TeleportWithDirection from 'dashboard/components-next/TeleportWithDirection.vue';
import Button from 'dashboard/components-next/button/Button.vue';

defineProps({
  src: {
    type: String,
    required: true,
  },
  name: {
    type: String,
    default: '',
  },
});

const emit = defineEmits(['close']);

onKeyStroke('Escape', () => emit('close'));
</script>

<template>
  <TeleportWithDirection>
    <div
      class="fixed inset-0 z-[10000] flex flex-col items-center justify-center gap-4 p-6 bg-black/85"
      role="dialog"
      aria-modal="true"
      :aria-label="name"
      @click.self="emit('close')"
    >
      <div class="absolute top-4 ltr:right-4 rtl:left-4">
        <Button
          v-tooltip="$t('GENERAL.CLOSE')"
          icon="i-lucide-x"
          ghost
          slate
          class="!text-white hover:!bg-white/10"
          @click="emit('close')"
        />
      </div>
      <img
        :src="src"
        :alt="name"
        class="max-w-full rounded-lg shadow-2xl object-contain max-h-[80vh] w-[min(640px,90vw)]"
      />
      <p v-if="name" class="text-base font-medium text-white">{{ name }}</p>
    </div>
  </TeleportWithDirection>
</template>
